export default __webpack_public_path__ + "static/media/jolie.44c79032.jpg";